/* unplugin-vue-components disabled */import { render } from "./fujianshifanType.vue?vue&type=template&id=f10ea0de&scoped=true"
import script from "./fujianshifanType.vue?vue&type=script&lang=js"
export * from "./fujianshifanType.vue?vue&type=script&lang=js"

import "./fujianshifanType.vue?vue&type=style&index=0&id=f10ea0de&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f10ea0de"]])

export default __exports__